import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default {
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var token, _yield$app$$api$check, storeStatus, _token;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              token = YL.cookies.get(process.env.VUE_APP_LOGIN_TOKEN) || false;

              if (!token) {
                _context.next = 10;
                break;
              }

              _context.next = 4;
              return app.$api.checkTokenStatus();

            case 4:
              _yield$app$$api$check = _context.sent;
              storeStatus = _yield$app$$api$check.storeStatus;
              _token = _yield$app$$api$check.token;
              app.$store.dispatch('d2admin/user/setCheckTokenStatus', storeStatus);
              YL.cookies.set(process.env.VUE_APP_LOGIN_TOKEN, _token);
              YL.isStoreAuto(storeStatus);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              from.meta["__stamp-".concat(from.path)] = Date.now();
              next(function (instance) {
                return instance.$router.replace({
                  path: from.fullPath,
                  meta: from.meta
                });
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  render: function render(h) {
    return h();
  }
};